import React, { useState, useEffect, useMemo } from 'react';
import { Disclosure } from '@headlessui/react';
import { t } from 'ttag';

import { Button } from '@components';
import Membership from '../../../modules/Membership/Membership';
import { useNavigation } from '../context/NavigationContext';

export default function Navigation() {
  const { navigationItems } = useNavigation();

  const [USPs, setUSPs] = useState([]);

  const USPType = useMemo(() => 'signup_unisport_fc_-_usp', []);

  useEffect(() => {
    const fetchUSPs = async () => {
      const response = await fetch(`/api/get_usp/?type=${USPType}`);
      const data = await response.json();

      if (data && data[USPType]) {
        setUSPs(data[USPType].slice(0, 3));
      }
    };
    fetchUSPs();
  }, []);

  const filteredNavigationItems = navigationItems
    .filter(item => item.online)
    .map(item => {
      const filteredSubItems = item.items.filter(subItem => subItem.online);
      return { ...item, items: filteredSubItems };
    });
  function normalizeUrl(url) {
    if (/^https?:\/\//.test(url)) {
      // It's an absolute URL, return as is
      return url;
    }
    // It's a relative URL, ensure it starts with a '/'
    return url.startsWith('/') ? url : `/${url}`;
  }

  return (
    <section className="px-3 py-12 md:flex lg:py-20 lg:pb-2 lg:pt-20">
      <div className="m-0 md:w-1/2 lg:w-2/5">
        <div className="max-w-[366px] md:mr-8">
          <Membership>
            <Membership.Heading> {t`Become a Member Today`}</Membership.Heading>

            <Membership.USPs>
              {USPs?.map(({ headline }) => (
                <Membership.USP key={headline}>{headline}</Membership.USP>
              ))}
            </Membership.USPs>
            <div className="flex gap-x-2">
              <Membership.Button
                as="button"
                onClick={() => {
                  window.location.href = `/account/login`;
                }}
              >
                {t`Join for Free`}
              </Membership.Button>
              <Membership.Button
                as="a"
                href="/account/login/"
                className="border-black bg-transparent text-black"
              >
                {t`Login`}
              </Membership.Button>
            </div>
          </Membership>
        </div>
      </div>

      <div className="min-h-[192px] pt-12 sm:p-2 md:w-1/2 lg:hidden">
        {filteredNavigationItems?.map(
          ({ title, items, slug, base_item_id: itemId }) =>
            title && items?.length > 0 ? (
              <Disclosure key={itemId}>
                {({ open }) => (
                  <>
                    <Disclosure.Button className="flex w-full justify-between border-none bg-transparent p-0 pt-4 text-left text-base font-bold focus:outline-none">
                      <span>{title}</span>

                      <svg
                        className={`${
                          open ? 'rotate-180 transform' : ''
                        } h-5 w-5`}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                      >
                        <path d="M11.9997 13.1714L16.9495 8.22168L18.3637 9.63589L11.9997 15.9999L5.63574 9.63589L7.04996 8.22168L11.9997 13.1714Z" />
                      </svg>
                    </Disclosure.Button>
                    <Disclosure.Panel className="pb-2 pt-4">
                      {items?.map(
                        ({
                          title: itemTitle,
                          slug: subItemSlug,
                          base_item_id: subItemId
                        }) => (
                          <a
                            key={subItemId}
                            className="block pt-4 text-sm font-bold text-dark-gray"
                            href={normalizeUrl(subItemSlug)}
                          >
                            {itemTitle}
                          </a>
                        )
                      )}
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ) : (
              <Button
                key={itemId}
                variant="tertiary"
                as="a"
                href={`/${slug}`}
                className="m-0 p-0"
              >
                <Button.Text className="p-0 pt-4 text-left text-base font-bold">
                  {title}
                </Button.Text>
              </Button>
            )
        )}
      </div>
      <div className="hidden gap-8 lg:grid lg:w-3/5 lg:grid-cols-4">
        {filteredNavigationItems?.map(
          ({ title, items, base_item_id: itemId, slug }) => (
            <div key={itemId}>
              {title && items.length > 0 ? (
                <>
                  <h2 className=" m-0 text-lg font-bold">{title}</h2>
                  <ul className="">
                    {items?.map(
                      ({
                        title: itemTitle,
                        slug: subItemSlug,
                        base_item_id: subItemId
                      }) => (
                        <li key={subItemId}>
                          <a
                            className="block pt-4 text-sm font-bold text-dark-gray hover:underline"
                            href={normalizeUrl(subItemSlug)}
                          >
                            {itemTitle}
                          </a>
                        </li>
                      )
                    )}
                  </ul>
                </>
              ) : (
                <Button
                  variant="tertiary"
                  as="a"
                  href={`/${slug}`}
                  className="m-0 p-0"
                >
                  <Button.Text className="p-0 text-lg font-bold">
                    {title}
                  </Button.Text>
                </Button>
              )}
            </div>
          )
        )}
      </div>
    </section>
  );
}
